import { useEffect, useRef, useState } from "react";
import "./firmLicenseGate.css";

const LICENSE_API_URL =
  "https://www.mobresapim.com.tr/lisansms/api/integration/qrsifsor";
const licenseRequests = new Map();

function normalizeFirmId(value) {
  return String(value ?? "")
    .trim()
    .split(/[#/]/)[0]
    .toUpperCase();
}

async function verifyFirm(firmId) {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), 10000);

  try {
    const response = await fetch(
      `${LICENSE_API_URL}/${encodeURIComponent(firmId)}`,
      {
        signal: controller.signal,
        cache: "no-store",
        headers: { Accept: "application/json" },
      }
    );

    if (!response.ok) return false;

    const license = await response.json();
    const returnedFirmId = normalizeFirmId(license?.data?.firmaKod);

    return (
      license?.success === true &&
      license?.data?.aktif === true &&
      returnedFirmId === firmId
    );
  } catch {
    return false;
  } finally {
    window.clearTimeout(timeoutId);
  }
}

function getFirmStatus(firmId) {
  if (!licenseRequests.has(firmId)) {
    licenseRequests.set(firmId, verifyFirm(firmId));
  }

  return licenseRequests.get(firmId);
}

export default function FirmLicenseGate({ firmId, children, onActive }) {
  const normalizedFirmId = normalizeFirmId(firmId);
  const [status, setStatus] = useState(
    normalizedFirmId ? "checking" : "inactive"
  );
  const onActiveRef = useRef(onActive);
  onActiveRef.current = onActive;

  useEffect(() => {
    let disposed = false;

    if (!normalizedFirmId) {
      setStatus("inactive");
      return () => {
        disposed = true;
      };
    }

    setStatus("checking");
    getFirmStatus(normalizedFirmId).then((isActive) => {
      if (!disposed) setStatus(isActive ? "active" : "inactive");
    });

    return () => {
      disposed = true;
    };
  }, [normalizedFirmId]);

  useEffect(() => {
    if (status === "active") onActiveRef.current?.();
  }, [status]);

  if (status === "checking") {
    return (
      <main className="mobres-firm-gate" aria-label="Firma kontrol ediliyor">
        <span className="mobres-firm-gate__spinner" aria-hidden="true" />
      </main>
    );
  }

  if (status !== "active") {
    return (
      <main className="mobres-firm-gate mobres-firm-gate--inactive">
        <p>
          Mobres <span aria-hidden="true">|</span>{" "}
          <a href="tel:4443610">444 36 10</a>
        </p>
      </main>
    );
  }

  return <>{children}</>;
}
